<template>
  <div class="wrapper-content w-100">
    <div class="row">
      <div class="col-12">
        <FormulateForm
          v-model="values"
          :schema="schema"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      values: {},
      schema: [
        {
          type: 'password',
          name: 'password',
          label: 'Enter a new password',
          validation: 'required'
        },
        {
          type: 'password',
          name: 'password_confirm',
          label: 'Confirm your password',
          validation: '^required|confirm:password',
          validationName: 'Password confirmation'
        },
        {
          type: 'submit',
          label: 'Change password'
        }
      ]
    }
  }
}
</script>
